module.exports = __webpack_public_path__ + "img/5.467249de.png";